import { Card } from '@helix-ds/react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
  return (
    <div className="bg-bg-secondary flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <h1 className="text-text-heading text-lg font-semibold">
          <FormattedMessage id="notFound.heading" defaultMessage="Page not found" />
        </h1>
        <p className="text-text-body mt-2 text-sm">
          <FormattedMessage id="notFound.body" defaultMessage="The page you're looking for doesn't exist." />
        </p>
        <div className="mt-4">
          <Link className="text-brand-600 hover:text-brand-700 dark:text-brand-400 text-sm font-medium" to="/home">
            <FormattedMessage id="notFound.cta" defaultMessage="Go to home" />
          </Link>
        </div>
      </Card>
    </div>
  )
}

export default NotFound
